<template>
  <div class="popup_wrap">
    <span @click="openDetailModal">
      <slot />
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="상세보기">
      <h5 class="stitle2 mb10">예약상세</h5>
      <div class="tb_wrap mb20">
        <table class="tb_basic">
          <caption>예약정보</caption>
          <colgroup>
            <col width="120" />
            <col />
            <col width="120" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>예약번호</th>
              <td>{{ rvDetail.bundleRvNo }}</td>
              <th>예약상태</th>
              <td>{{ rvDetail.rvProgSituNm }}</td>
            </tr>
            <tr>
              <th>상품</th>
              <td>{{ rvDetail.pdNm }}</td>
              <th>체험일</th>
              <td>{{ rvDetail.expVisitRvdtF }}</td>
            </tr>
            <tr>
              <th>회차</th>
              <td colspan="3">{{ rvDetail.scheSeqNm }}{{ rvDetail.tm }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h5 class="stitle2 mb20">체험자 및 인솔자(보호자)인원</h5>
      <div class="tb_wrap mb20">
        <table class="tb_basic">
          <caption>체험자 및 인솔자(보호자)인원</caption>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr class="tbg">
              <th scope="col">구분</th>
              <th scope="col">할인내용</th>
              <th scope="col">할인율</th>
              <th scope="col">신청인원</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rvPesn, i) in rvPesn20List" :key="rvPesn.reciDivCd + rvPesn.pesnDivCd + rvPesn.pdNo">
              <td v-if="i === 0" :rowspan="rvPesn20List.length">{{ rvPesn.reciDivNm }}</td>
              <td>{{ rvPesn.note }}</td>
              <td>{{ rvPesn.discRateView }}</td>
              <td>
                {{ rvPesn.pcnt }}
              </td>
            </tr>
            <tr v-for="(rvPesn, i) in rvPesn10List" :key="rvPesn.reciDivCd + rvPesn.pesnDivCd + rvPesn.pdNo">
              <td v-if="i === 0" :rowspan="rvPesn10List.length">{{ rvPesn.reciDivNm }}</td>
              <td>{{ rvPesn.note }}</td>
              <td>{{ rvPesn.discRateView }}</td>
              <td>
                {{ rvPesn.pcnt }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--양식지 안내-->
      <div v-if="rvDetail.groupPersDiv === '01'" class="colorBox mb20">
        <p class="mb10">할인대상자가 있을 경우 아래 양식을 다운받아 작성하여 체험당일 지참해 주시기 바랍니다.</p>
        <div class="ticket_btnbox">
          <a href="/file/koreajobworldHM_New.hwp" target="_blank" class="btn_down">할인/면제대상 확인서</a>
        </div>
      </div>
      <!--//양식지 안내-->

      <template v-if="rvDetailScheList.length > 1">
        <h5 class="stitle2 mb10">
          회차별 체험자
          <select v-model="selectedDetailSche">
            <option v-for="(sche, i) in rvDetailScheList" :key="i" :value="sche">{{ sche.scheSeqNm }}</option>
          </select>
        </h5>
      </template>
      <template v-if="experInfoList.length > 0">
        <template v-if="rvPdScheInfo.capaPcntType === '01'">
          <div v-if="exhpEdit" class="exhp-edit-box">
            <h5 class="stitle2 mb10">
              체험실 선택 - {{ experList.length }}명 ({{ currentExperInfo.pcnt }}명)
              <div class="private-box">
                <private-agree-popup v-model="privateAgreeExhp" id="exhp" />
              </div>
              <div class="tit_btnbox">
                <a class="btn" @click="toggleEdit">취소</a>
                <a class="btn_color" @click="updateExperInfo">저장</a>
              </div>
            </h5>
            <div class="road-tabs reserv_deatil">
              <div class="tabs">
                <TabItem
                  v-for="road in roadList"
                  :id="road.exhpHzCd"
                  :label="road.exhpHallNm"
                  :subLabel="road.exhpAppPcnt"
                  :maxLabel="road.streetRemain"
                  :caution="road.exhpAppPcnt > road.streetRemain"
                  :key="road.exhpHzCd"
                  v-model="currentRoadId"
                />
              </div>
              <div class="contents">
                <transition>
                  <section class="item" :key="currentRoadId">
                    <div class="hall-list">
                      <div v-for="exhp in currentRoad.exphList" :key="exhp.exhpHzCd" class="hall">
                        <div>
                          {{ exhp.exhpHallNm }}
                          -
                          <span :class="{ caution: exhp.exhpAppPcnt > exhp.exhpRvResiduePcnt }">{{ exhp.exhpAppPcnt }} ({{ exhp.exhpRvResiduePcnt }})</span>
                        </div>
                        <div>
                          <button @click="() => onExhpClick(exhp)">{{ exhpAddText }}</button>
                        </div>
                      </div>
                    </div>
                  </section>
                </transition>
              </div>
            </div>
          </div>
          <template v-else>
            <h5 class="stitle2 mb10">
              체험실 선택
              <div v-if="editExhpAble" class="tit_btnbox"><a class="btn_color" @click="toggleEdit">수정</a></div>
            </h5>
          </template>
          <div class="tb_wrap mb20">
            <table class="tb_basic mb10">
              <caption></caption>
              <colgroup>
                <col width="60px" />
                <col width="100px" />
                <col />
                <col />
                <col width="60px" />
                <col width="60px" />
                <col />
                <col />
                <col />
                <col v-if="exhpEdit" width="70px" />
                <!-- <col width="20%" /> -->
              </colgroup>
              <thead>
                <tr class="tbg">
                  <th scope="col">번호</th>
                  <th scope="col">
                    체험자명
                    <sup class="red">*</sup>
                  </th>
                  <th scope="col">ID</th>
                  <th scope="col">
                    학년
                    <sup class="red">*</sup>
                  </th>
                  <th scope="col">반</th>
                  <th scope="col">번호</th>
                  <th scope="col">생년월일</th>
                  <th scope="col">
                    Email
                    <sup class="red">*</sup>
                  </th>
                  <th scope="col">
                    체험실
                    <sup class="red">*</sup>
                  </th>
                  <th v-if="exhpEdit" scope="col">{{ exhpRemoveText }}</th>
                  <!-- <th scope="col">복지할인 정보</th> -->
                </tr>
              </thead>
              <tbody v-if="exhpEdit" class="editable">
                <tr v-for="(exper, i) in experList" :key="exper.incluId">
                  <td>{{ i + 1 }}</td>
                  <td><input type="text" v-model="exper.incluNm" maxlength="10" /></td>
                  <td><input type="text" v-model="exper.incluUserId" maxlength="50" /></td>
                  <td>
                    <select v-model="exper.incluGrade" @change="() => gradeChange(exper, currentExperInfo.gradeList)">
                      <option v-for="grade in currentExperInfo.gradeList" :key="grade.cd" :value="grade.cd">
                        {{ grade.cdNm }}
                      </option>
                    </select>
                  </td>
                  <td><input type="text" v-model="exper.incluClass" maxlength="10" /></td>
                  <td><input type="text" v-model="exper.incluClsNo" maxlength="10" /></td>
                  <td><input type="text" v-model="exper.incluBirthMonDate" maxlength="20" /></td>
                  <td><input type="text" v-model="exper.email" maxlength="100" /></td>
                  <td>
                    <span v-if="exper.exhpHallNm">{{ exper.exhpHallNm }}</span>
                    <button v-else-if="!selectedExper" @click="() => onSelectExper(exper)" class="clickable">선택</button>
                    <span v-else-if="selectedExper === exper">
                      상단 체험실을
                      <br />
                      클릭하세요
                    </span>
                  </td>
                  <td>
                    <button v-if="isGroup || exper.exhpHzCd" @click="() => onDeleteExper(exper)" class="clickable">{{ exhpRemoveText }}</button>
                  </td>
                  <!-- <td>일반</td> -->
                </tr>
                <tr v-if="experList.length < 1">
                  <td colspan="10"><div style="margin: 5px">체험실 선택 정보가 없습니다. 상단 체험실 목록에서 추가 버튼을 클릭하세요.</div></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(exper, i) in experList" :key="exper.incluId">
                  <td>{{ i + 1 }}</td>
                  <td>{{ exper.incluNm }}</td>
                  <td>{{ exper.incluUserId }}</td>
                  <td>{{ exper.gradeNm }}</td>
                  <td>{{ exper.incluClass }}</td>
                  <td>{{ exper.incluClsNo }}</td>
                  <td>{{ exper.incluBirthMonDate }}</td>
                  <td>{{ exper.email }}</td>
                  <td>{{ exper.exhpHallNm }}</td>
                  <!-- <td>일반</td> -->
                </tr>
              </tbody>
            </table>
            <ul v-if="exhpEdit" class="colorbox tcolor2 mb20 posUnset">
              <li>* 동명 이인이 있는 경우 1,2로 구분해주세요 예)홍길동1, 홍길동2/홍길동1반, 홍길동2반</li>
              <li>* 이름과 E-mail이 중복되면 체험실저장이 정상적으로 저장 되지 않습니다.</li>
            </ul>
            <div class="colorBox mb20 posUnset">
              <div class="ticket_btnbox">
                <a href="#" @click="fnSelectExhpHall" class="btn_color1 btnMd01 btn3rd">
                  <span>선택현황 다운로드</span>
                </a>
                <template v-if="rvDetail.groupPersDiv === '01' && editExhpAble">
                  <a v-if="rvDetail.pdDiv == '10'" href="/file/skillExperienceRoomExcel.xls" target="_blank" class="btn_color1 btnMd01 btn3rd">
                    <span>양식 다운로드</span>
                  </a>
                  <a v-if="rvDetail.pdDiv == '02'" href="/file/experienceRoomExcel.xls" target="_blank" class="btn_color1 btnMd01 btn3rd">
                    <span>양식 다운로드</span>
                  </a>
                  <a @click="$refs.file.click()" class="btn_color1 btnMd01 btn3rd">
                    <input type="file" ref="file" name="file1" @change="openExcelPop" style="display: none" />
                    <span>엑셀 업로드</span>
                  </a>
                </template>
                <template v-else>
                  <span>&nbsp; 결제완료/확약서 확인 완료 후 체험실 선택을 하실 수 있습니다.</span>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="experList.length > 0">
          <div v-if="includeEdit" class="exhp-edit-box">
            <h5 class="stitle2 mb10">
              체험자 목록
              <div class="private-box">
                <private-agree-popup v-model="privateAgreeInclude" id="include" />
              </div>
              <div class="tit_btnbox">
                <a class="btn" @click="toggleIncludeEdit">취소</a>
                <a class="btn_color" @click="updateExperInfo">저장</a>
              </div>
            </h5>
          </div>
          <h5 v-else class="stitle2 mb10">
            체험자 목록
            <div v-if="editAble" class="tit_btnbox"><a class="btn_color" @click="toggleIncludeEdit">수정</a></div>
          </h5>
          <div class="tb_wrap mb20">
            <table class="tb_basic" id="childInfoT">
              <caption></caption>
              <colgroup>
                <col width="10%" />
                <col width="20%" />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr class="tbg">
                  <th scope="col">번호</th>
                  <th scope="col">체험자명</th>
                  <th scope="col">학년</th>
                  <th scope="col">생년월일</th>
                </tr>
              </thead>
              <tbody v-if="includeEdit" class="editable">
                <tr v-for="(exper, i) in experList" :key="exper.incluId">
                  <td>{{ i + 1 }}</td>
                  <td><input type="text" v-model="exper.incluNm" maxlength="10" /></td>
                  <td>
                    <select v-model="exper.incluGrade" @change="() => gradeChange(exper, currentExperInfo.gradeList)">
                      <option v-for="grade in currentExperInfo.gradeList" :key="grade.cd" :value="grade.cd">
                        {{ grade.cdNm }}
                      </option>
                    </select>
                  </td>
                  <td><input type="text" v-model="exper.incluBirthMonDate" maxlength="20" /></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(exper, i) in experList" :key="exper.incluId">
                  <td>{{ i + 1 }}</td>
                  <td>{{ exper.incluNm }}</td>
                  <td>{{ exper.gradeNm }}</td>
                  <td>{{ exper.incluBirthMonDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </template>

      <template v-if="leaderInfoList.length > 0">
        <div v-if="leaderEdit" class="exhp-edit-box">
          <h5 class="stitle2 mb10">
            인솔자 목록
            <div class="private-box">
              <private-agree-popup v-model="privateAgreeLeader" id="leader" />
            </div>
            <div class="tit_btnbox">
              <a class="btn" @click="toggleLeaderEdit">취소</a>
              <a class="btn_color" @click="updateLeaderInfo">저장</a>
            </div>
          </h5>
        </div>
        <h5 v-else class="stitle2 mb10">
          인솔자목록
          <div v-if="editAble" class="tit_btnbox"><a class="btn_color" @click="toggleLeaderEdit">수정</a></div>
        </h5>
        <div class="people_input_modal_list tb_wrap mb30" name="p_leaderPcnt">
          <table class="tb_basic">
            <caption>인솔자목록 리스트</caption>
            <colgroup>
              <col width="10%" />
              <col width="20%" />
              <col />
              <col />
              <!-- <col width="20%" /> -->
            </colgroup>
            <thead>
              <tr class="tbg">
                <th scope="col">번호</th>
                <th scope="col">인솔자명</th>
                <th scope="col">휴대폰</th>
                <th scope="col">E-mail</th>
                <!-- <th scope="col">복지할인 정보</th> -->
              </tr>
            </thead>
            <tbody v-if="leaderEdit" class="editable">
              <tr v-for="(leader, i) in leaderList" :key="leader.leaderId">
                <td>{{ i + 1 }}</td>
                <td><input type="text" v-model="leader.leaderNm" maxlength="10" /></td>
                <td><input type="text" v-model="leader.phoneNo" maxlength="15" /></td>
                <td><input type="text" v-model="leader.email" maxlength="20" /></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(leader, i) in leaderList" :key="leader.leaderId">
                <td>{{ i + 1 }}</td>
                <td>{{ leader.leaderNm }}</td>
                <td>{{ leader.phoneNo }}</td>
                <td>{{ leader.email }}</td>
                <!-- <td>일반</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <div class="btn_wrap">
        <a class="all-full btn btn_bg gray" @click="closeModal">닫기</a>
      </div>
      <template slot="footer"></template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import api from '@/api/api_config';
import { mapActions } from 'vuex';
import { isLoggedIn } from '@/utils/reserve';
import { getReservationPdDetail, postReservationPdExperInfo, postReservationPdLeaderInfo, getReservationPdDetailExperList } from '@/api/api_reserve';
import Modal from '@/components/common/Modal.vue';
import TabItem from '@/components/common/TabItem.vue';
import PrivateAgreePopup from '@/components/popup/PrivateAgreePopup.vue';
import { read, utils, writeFileXLSX } from 'xlsx';

//확장자 확인
function checkFileType(filePath) {
  var fileFormat = filePath.split('.');
  if (fileFormat.indexOf('xls') > -1) {
    return true;
  } else {
    return false;
  }
}

export default {
  components: { Modal, TabItem, PrivateAgreePopup },
  props: {
    pdRvNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modal: {
        open: false,
      },
      rvDetail: {},
      rvDetailScheList: [],
      rvPesn20List: [],
      rvPesn10List: [],
      experInfoList: [],
      leaderInfoList: [],
      experList: [],
      leaderList: [],
      roadList: [],
      gradeList: [],
      cloneList: [],
      cloneLeaderList: [],
      cloneRoadList: [],
      selected: 0,
      selectedExper: null,
      selectedDetailSche: null,
      currentExperInfo: {},
      currentRoadId: '',
      includeEdit: false,
      leaderEdit: false,
      exhpEdit: false,
      privateAgreeInclude: false,
      privateAgreeLeader: false,
      privateAgreeExhp: false,
    };
  },
  computed: {
    currentRoad() {
      return this.roadList.find((el) => el.exhpHzCd === this.currentRoadId) || {};
    },
    editAble() {
      return this.rvDetail.rvProgSitu !== '05';
    },
    editExhpAble() {
      const rvProgSitu = this.rvDetail.rvProgSitu;
      //rvDetail.groupPersDiv === '01'
      if (rvProgSitu === '10') {
        return this.rvDetail?.expVisitRvdtRemain < 15;
      } else {
        return rvProgSitu === '03' || rvProgSitu === '02';
      }
    },
    exhpAddText() {
      return this.selectedExper ? '선택' : '추가';
    },
    isGroup() {
      return this.rvDetail.groupPersDiv === '01';
    },
    exhpRemoveText() {
      return this.isGroup ? '삭제' : '변경';
    },
    rvPdScheInfo() {
      return this.selectedDetailSche || this.rvDetail;
    },
  },
  watch: {
    'modal.open': function (to) {
      if (to) {
        this.loadDetailData();
      }
    },
    selectedDetailSche(to) {
      if (to) {
        if (this.exhpEdit) {
          this.toggleEdit();
        }
        this.loadExperInfo(to);
        this.currentExperInfo = this.experInfoList.find((ei) => ei.pdNo === to.pdNo && ei.scheSeqNo === to.scheSeqNo);
      }
    },
  },
  methods: {
    ...mapActions('reserve', ['editReserveInfo']),
    gradeChange(row, gl) {
      if (row?.incluGrade && gl) {
        row.gradeNm = gl.find((e) => e.cd === row.incluGrade).cdNm;
      }
    },
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      if (this.includeEdit) {
        this.toggleIncludeEdit();
      }
      if (this.leaderEdit) {
        this.toggleLeaderEdit();
      }
      if (this.exhpEdit) {
        this.toggleEdit();
      }

      this.selectedExper = null;
      this.selectedDetailSche = null;
      this.modal.open = false;
    },
    openDetailModal() {
      if (isLoggedIn()) {
        this.openModal();
      }
    },
    onExhpClick(exhp) {
      const experInfo = this.currentExperInfo;
      const streetRemain = this.currentRoad.streetRemain;
      const selectedExper = this.selectedExper;

      if (!experInfo) {
        alert('오류가 발생하였습니다.');
        return false;
      }

      if (!selectedExper && experInfo.pcnt <= this.experList.length) {
        alert('예약 인원 수 만큼 체험실 선택이 되었습니다.');
        return false;
      }

      if (streetRemain > 0 && this.currentRoad.exhpAppPcnt >= streetRemain) {
        alert('분야 할당 인원수를 초과하였습니다.');
        return false;
      }

      if (exhp.exhpRvResiduePcnt > exhp.exhpAppPcnt) {
        if (selectedExper) {
          this.selectedExper.exhpHallNm = exhp.exhpHallNm;
          this.selectedExper.exhpHzCd = exhp.exhpHzCd;
          this.selectedExper.exhpStreetCd = exhp.upperCd;

          this.selectedExper = null;
        } else {
          const pcnt = {
            incluNm: '',
            incluUserId: '',
            incluGrade: experInfo.gradeList?.[0].cd,
            gradeNm: experInfo.gradeList?.[0].cdNm,
            incluClass: '',
            incluClsNo: '',
            incluBirthMonDate: '',
            email: '',
            exhpHallNm: exhp.exhpHallNm,
            exhpHzCd: exhp.exhpHzCd,
            exhpStreetCd: exhp.upperCd,
            pdRvNo: this.pdRvNo,
            pdNo: experInfo.pdNo,
            scheSeqNo: experInfo.scheSeqNo,
            pesnDivCd: '',
          };
          this.experList.push(pcnt);
        }

        this.currentRoad.exhpAppPcnt += 1;
        exhp.exhpAppPcnt += 1;
      }
    },
    onSelectExper(exper) {
      this.selectedExper = exper;
    },
    onDeleteExper(exper) {
      let result = false;
      if (exper.exhpHzCd) {
        result = this.roadList.some((road) => {
          return (
            road.exhpHzCd === exper.exhpStreetCd &&
            road.exphList.some((e) => {
              if (e.exhpHzCd === exper.exhpHzCd) {
                road.exhpAppPcnt -= 1;
                e.exhpAppPcnt -= 1;
                return true;
              } else {
                return false;
              }
            })
          );
        });
      } else {
        result = true;
      }
      if (result) {
        if (this.isGroup) {
          //그룹일경우 삭제
          this.experList = this.experList.filter((e) => e !== exper);
        } else {
          //개인일경우 체험실 취소
          exper.exhpHallNm = null;
          exper.exhpHzCd = null;
          exper.exhpStreetCd = null;
          //후 선택
          this.selectedExper = exper;
        }
      }
    },
    toggleIncludeEdit() {
      if (this.includeEdit) {
        this.experList = this.cloneList;
        this.cloneList = [];
      } else {
        this.cloneList = cloneDeep(this.experList);
      }

      this.includeEdit = !this.includeEdit;
    },
    toggleLeaderEdit() {
      if (this.leaderEdit) {
        this.leaderList = this.cloneLeaderList;
        this.cloneLeaderList = [];
      } else {
        this.cloneLeaderList = cloneDeep(this.leaderList);
      }
      this.leaderEdit = !this.leaderEdit;
    },
    toggleEdit() {
      if (this.exhpEdit) {
        this.experList = this.cloneList;
        this.roadList = this.cloneRoadList;
        this.cloneList = [];
        this.cloneRoadList = [];
        this.selectedExper = null;
      } else {
        this.cloneList = cloneDeep(this.experList);
        this.cloneRoadList = cloneDeep(this.roadList);
      }
      this.exhpEdit = !this.exhpEdit;
    },
    openEdit() {
      if (!this.exhpEdit) {
        this.toggleEdit();
      }
    },
    setPcntCount(experList, roadList) {
      roadList.forEach((e) => (e.exhpAppPcnt = 0));
      experList.forEach((exper) => {
        roadList.some((road) => {
          return (
            road.exhpHzCd === exper.exhpStreetCd &&
            road.exphList.some((e) => {
              if (e.exhpHzCd === exper.exhpHzCd) {
                road.exhpAppPcnt += 1;
                e.exhpAppPcnt += 1;
                return true;
              } else {
                return false;
              }
            })
          );
        });
      });
    },
    loadDetailData() {
      getReservationPdDetail(this.pdRvNo).then((data) => {
        if (data.success) {
          const { rvDetail, roadList, experList, streetRemain } = data.response;
          const { pesnInfoList = [], rvPesnList = [] } = data.response;
          //체험자 카운트
          if (experList && roadList) {
            this.setPcntCount(experList, roadList);
          }
          //단체 청소년 체험관 거리별 인원 제한
          if (rvDetail.groupPersDiv === '01' && rvDetail.pdDiv === '02') {
            //일단 하드코딩
            const streetMap = new Map();
            streetMap.set('2100001', streetRemain.groupA);
            streetMap.set('2100002', streetRemain.groupB);
            streetMap.set('2100004', streetRemain.groupC);
            streetMap.set('2100005', streetRemain.groupD);
            streetMap.set('2100006', streetRemain.groupE);

            roadList.forEach((e) => {
              const stRemain = streetMap.get(e.exhpHzCd);
              if (stRemain) {
                e.streetRemain = stRemain;
              }
            });
          }
          //rvDetail.pdDiv
          //streetRemain;
          const leaderInfoList = [];
          const experInfoList = [];
          pesnInfoList.forEach((e) => {
            if (e.reciDivCd === '20') {
              experInfoList.push(e);
            } else if (e.reciDivCd === '10') {
              leaderInfoList.push(e);
            }
          });

          this.rvPesn20List = rvPesnList.filter((e) => e.reciDivCd === '20' && e.pcnt > 0);
          this.rvPesn10List = rvPesnList.filter((e) => e.reciDivCd === '10' && e.pcnt > 0);
          this.currentExperInfo = experInfoList[0];
          this.rvDetail = rvDetail;
          this.leaderInfoList = leaderInfoList;
          this.experInfoList = experInfoList;
          this.leaderList = data.response.leaderList;
          this.experList = experList;
          this.roadList = roadList;
          this.rvDetailScheList = data.response.rvDetailScheList;
          if (rvDetail.mrktnPdYn === 'Y') {
            this.selectedDetailSche = this.rvDetailScheList[0];
          }

          if (this.roadList?.length > 0) {
            this.currentRoadId = this.roadList[0].exhpHzCd;
          }
        }
      });
    },
    async updateExperInfo() {
      if (this.currentExperInfo.pcnt < this.experList.length) {
        alert('예약 인원보다 더 많은 체험자가 입력되었습니다.');
        return false;
      }

      if (this.roadList.length > 0) {
        const overStreet = this.roadList.find((e) => e.streetRemain > 0 && e.exhpAppPcnt > e.streetRemain);
        if (overStreet) {
          alert(overStreet.exhpHallNm + ' 체험실 선택 인원이 분야별 인원 제한을 초과하였습니다.');
          return false;
        }
        const overHxhp = this.roadList.some((road) => {
          return road.exphList.some((e) => {
            if (e.exhpAppPcnt > e.exhpRvResiduePcnt) {
              alert(road.exhpHallNm + ' ' + e.exhpHallNm + ' 체험실 선택 인원이 초과하였습니다.');
              return true;
            } else {
              return false;
            }
          });
        });

        if (overHxhp) {
          return false;
        }
      }

      if ((this.includeEdit && !this.privateAgreeInclude) || (this.exhpEdit && !this.privateAgreeExhp)) {
        alert('개인정보 동의를 체크해 주십시오.');
        return false;
      }

      const valueValid = this.experList.every((e, i) => {
        if (!e.incluNm) {
          alert('체험자 이름을 입력해 주십시오.');
          return false;
        }
        if (!e.incluGrade) {
          alert('체험자 학년을 입력해 주십시오.');
          return false;
        }
        if (this.rvPdScheInfo.capaPcntType === '01' && !e.email) {
          alert('체험자 이메일을 입력해 주십시오.');
          return false;
        }
        return true;
      });

      if (!valueValid) {
        return false;
      }

      const duplIdChk = this.experList.some((value, index, self) => {
        return self.findIndex((t, j) => j > index && t.incluUserId && t.incluUserId === value.incluUserId) > 0;
      });

      if (duplIdChk) {
        alert('동일ID가 존재합니다. ID를 확인해 주세요.');
        return false;
      }

      const duplNameChk = this.experList.some((value, index, self) => {
        return self.findIndex((t, j) => j > index && t.email === value.email && t.incluNm === value.incluNm) > 0;
      });

      if (duplNameChk) {
        alert('동일 이름과 Email이 존재합니다. 이름과 Email을 확인해 주세요.');
        return false;
      }

      if (!confirm('체험자 정보를 수정하시겠습니까?')) {
        return false;
      }

      const reserve = {
        pdRvNo: this.pdRvNo,
        pdDiv: this.rvPdScheInfo.pdDiv,
        pdNo: this.rvPdScheInfo.pdNo,
        scheSeqNo: this.rvPdScheInfo.scheSeqNo,
        ndDt: this.rvDetail.expVisitRvdt,
        pcntList: this.experList,
      };
      try {
        const result = await postReservationPdExperInfo(this.pdRvNo, reserve);
        if (result.success) {
          alert(result.response.msg);
          this.includeEdit = false;
          this.exhpEdit = false;
          if (result.response.includeList) {
            //console.log(result.response.includeList);
            this.experList = result.response.includeList;
          }
        }
      } catch (e) {
        alert('오류가 발생 하였습니다.');
      }
    },
    async updateLeaderInfo() {
      if (!this.privateAgreeLeader) {
        alert('개인정보 동의를 체크해 주십시오.');
        return false;
      }

      const maxPcnt = this.leaderInfoList.reduce((a, e) => a + e, 0);
      if (maxPcnt < this.leaderList.length) {
        alert('예약 인원보다 더 많은 인솔자/보호자가 입력되었습니다.');
      }

      this.leaderList.every((leader) => {
        if (!leader.leaderNm) {
          alert('인솔자/보호자 이름은 필수 값 입니다.');
          return false;
        }
        if (!leader.phoneNo) {
          alert('인솔자/보호자 전화번호는 필수 값 입니다.');
          return false;
        }
        if (!leader.email) {
          alert('인솔자/보호자 이메일은 필 수 값 입니다.');
          return false;
        }
        return true;
      });

      if (!confirm('인솔자/보호자 정보를 수정하시겠습니까?')) {
        return false;
      }

      const reserve = {
        pdRvNo: this.pdRvNo,
        pdNo: this.rvDetail.mrktnPdYn === 'Y' ? this.leaderList[0]?.pdNo : this.rvDetail.pdNo,
        scheSeqNo: this.rvDetail.mrktnPdYn === 'Y' ? 0 : this.rvDetail.scheSeqNo,
        ndDt: this.rvDetail.expVisitRvdt,
        pcntList: this.leaderList,
      };
      try {
        const result = await postReservationPdLeaderInfo(this.pdRvNo, reserve);
        if (result.success) {
          alert(result.response.msg);
          this.leaderEdit = false;
        }
      } catch (e) {
        alert('오류가 발생 하였습니다.');
      }
    },
    async loadExperInfo(param) {
      try {
        const result = await getReservationPdDetailExperList(this.pdRvNo, param.pdNo, param.scheSeqNo, this.rvDetail.expVisitRvdt);
        if (result.success) {
          const { roadList, experList, streetRemain } = result.response;
          if (experList && roadList) {
            this.setPcntCount(experList, roadList);
          }
          this.experList = experList;
          this.roadList = roadList;
        }
      } catch (e) {
        alert('오류가 발생 하였습니다.');
      }
    },
    //체험실 선택 현황
    fnSelectExhpHall() {
      var frm = new FormData();
      for (var key in this.rvDetail) {
        frm.append(key, this.rvDetail[key]);
      }
      api
        .post('/resvr/selectExhpHallDetail.do', frm, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const fileName = '체험실 선택현황.xls';
          const data = response.data;
          if (!data) {
            return;
          }
          const url = window.URL.createObjectURL(new Blob([data]));
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.setAttribute('download', fileName);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          a.remove();
        })
        .catch((e) => {
          alert('오류가 발생하였습니다.');
        });
    },
    openExcelPop(e) {
      let file = e.target.files[0];

      if (!file) {
        alert('첨부된 파일이 없습니다.');
        return false;
      } else if (!checkFileType(file?.name)) {
        alert('양식 파일만 업로드가 가능합니다.');
        return false;
      }

      const experInfo = this.currentExperInfo;
      const exhpMap = new Map();
      this.roadList.forEach((road) => {
        road.exphList.forEach((exph) => {
          exhpMap.set(exph.exhpHallNm, { exph, road });
        });
      });

      const gradeMap = new Map();
      experInfo?.gradeList.forEach((e) => {
        gradeMap.set(e.cd, e.cdNm);
      });

      const pdRvNo = this.pdRvNo;
      const experList = this.experList;

      if (confirm('업로드 하시겠습니까?')) {
        this.openEdit();
        this.experList.splice(0);
        this.roadList.forEach((road) => {
          road.exhpAppPcnt = 0;
          road.exphList.forEach((e) => {
            e.exhpAppPcnt = 0;
          });
        });
        const reader = new FileReader();
        reader.onload = function (e) {
          let data = e.target.result;
          data = new Uint8Array(data);

          var workbook = read(data, {
            type: 'array',
          });

          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var excelExperList = utils.sheet_to_json(worksheet, {
            header: 1,
          });

          if (excelExperList.length < 2) {
            alert('엑셀 파일에 데이터가 없습니다.');
            return false;
          }

          let errRowCnt = 0;
          for (let i = 2; i < excelExperList.length; i++) {
            const row = excelExperList[i];
            //0:ID, 1: 이름, 2:학년, 3:반, 4:번호, 5:생년월일, 6:이메일, 7:분야명, 8:체험실
            if (row[1] && row[2] && row[6] && row[8]) {
              const value = exhpMap.get(row[8]);
              if (value) {
                const { exph, road } = value;
                const pcnt = {
                  incluNm: row[1],
                  incluUserId: row[0] || '',
                  incluGrade: row[2] || '',
                  gradeNm: gradeMap.get(row[2]) || '',
                  incluClass: row[3] || '',
                  incluClsNo: row[4] || '',
                  incluBirthMonDate: row[5] || '',
                  email: row[6] || '',
                  exhpHallNm: exph.exhpHallNm,
                  exhpHzCd: exph.exhpHzCd,
                  exhpStreetCd: exph.upperCd,
                  pdRvNo: pdRvNo,
                  pdNo: experInfo.pdNo,
                  scheSeqNo: experInfo.scheSeqNo,
                  pesnDivCd: '',
                };
                road.exhpAppPcnt += 1;
                exph.exhpAppPcnt += 1;
                experList.push(pcnt);
              } else {
                errRowCnt++;
              }
            } else {
              errRowCnt++;
            }
          }
          alert('업로드가 완료되었습니다.\n확인 후 저장 버튼을 클릭해 주세요.' + (errRowCnt > 0 ? `(${errRowCnt}건 오류)` : ''));
        };
        reader.readAsArrayBuffer(file);
      }
    },
  },
  created() {
    //this.openModal();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .pop_layer {
  min-width: 1024px;
  left: calc(50% - 500px);
  margin-left: 0;
  height: 700px;
  margin-top: -350px;
}

.posUnset {
  position: unset;
}

@media all and (max-width: 1024px) {
  ::v-deep .pop_layer {
    min-width: 100%;
    left: 0;
  }
}

.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
  & .checkbox input[type='checkbox'] + label {
    font-size: 16px;
    display: inline-block;
    height: 19px;
    padding-left: 23px;
    line-height: 19px;
    background-size: 19px 19px;
    width: initial;
  }

  & .tb_basic {
    & tbody.editable {
      & td {
        padding: 2px;

        & input {
          width: 100%;
          // height: 23px;
          // line-height: 21px;
          // padding: 0 5px;
        }
      }
    }
  }
}
.exhp-edit-box {
  position: sticky;
  top: 0;
  // background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 80%, rgba(255, 255, 255, 0.9) 100%);
  background: #fff;
  box-shadow: 0 4px 4px -4px black;
  padding-bottom: 5px;

  & .private-box {
    position: absolute;
    top: 0;
    right: 110px;
  }
}
@media all and (max-width: 540px) {
  .exhp-edit-box {
    & .tit_btnbox {
      position: absolute;
    }

    & .private-box {
      position: relative;
      height: 30px;
      margin-top: 10px;
      right: initial;
    }
  }
}

.road-tabs {
  display: flex;
  & .tabs {
    display: flex;
    flex-direction: column;
    width: 180px;
    flex-shrink: 0;
  }

  .contents {
    overflow: hidden;
    position: relative;
    flex: 1;
  }

  .item {
    box-sizing: border-box;
    padding: 0 10px;
    width: 100%;
    min-height: 100%;
    background: #f6f4fa;
    border-top: 1px solid #ddd;
    transition: all 0.8s ease;
  }

  & .hall-list {
    display: grid;
    grid-template-columns: auto auto auto;

    & > div {
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;
      padding: 2px 5px;
      font-size: 13px;
      border-bottom: 1px dashed #ddd;
      cursor: default;
      &:hover {
        background: #fafafa;
      }
    }
  }
}
.caution {
  color: #bd0000;
  font-weight: 500;
}
.red {
  color: #bd0000;
}

/* 트랜지션 전용 스타일 */
.v-leave-active {
  position: absolute;
}
.v-enter {
  transform: translateY(100%);
}
.v-leave-to {
  transform: translateY(-100%);
}
</style>
